module.exports = __webpack_public_path__ + "media/bootstrap-icons/arrow-right-square-fill-52d2124d.svg";